import React from 'react';

interface FilterSidebarProps {
	isOpen: boolean;
	toggleSidebar: () => void;
	setStartDateTime: any;
	setEndDateTime: any;
	setSelectedParentIntent: any;
	setSelectedChildIntent: any;
	parentIntents: string[];
	childIntents: string[];
}

const FilterSidebar: React.FC<FilterSidebarProps> = ({
	isOpen,
	toggleSidebar,
	setStartDateTime,
	setEndDateTime,
	setSelectedParentIntent,
	setSelectedChildIntent,
	parentIntents,
	childIntents,
}) => {
	const [selParentIntent, setSelParentIntent] = React.useState<string>('');
	const [selChildIntent, setSelChildIntent] = React.useState<string>('');
	const [startDate, setStartDate] = React.useState<string>('');
	const [endDate, setEndDate] = React.useState<string>('');
	const [startTime, setStartTime] = React.useState<string>('');
	const [endTime, setEndTime] = React.useState<string>('');
	const handleApplyFilters = () => {
		if (!startDate && !startTime && !endDate && !endTime && !selParentIntent && !selChildIntent) {
			alert('Please select at least one date/time field or intent before applying the filter.');
			return;
		}

		const combinedStartDate = startDate && startTime ? `${startDate} ${startTime}` : null;
		const combinedEndDate = endDate && endTime ? `${endDate} ${endTime}` : null;

		setStartDateTime(combinedStartDate);
		setEndDateTime(combinedEndDate);
		setSelectedParentIntent(selParentIntent || '');
		setSelectedChildIntent(selChildIntent || '');

		//onApply({});
	};

	if (!isOpen) return null;

	return (
		<div className="fixed inset-0 bg-gray-800 bg-opacity-50 flex justify-end z-50">
			<div className="bg-white w-[400px] p-6 rounded-lg shadow-lg flex flex-col justify-between h-full">
				<div>
					<div className="flex justify-between items-center mb-6">
						<h3 className="text-lg font-semibold text-gray-900">Filter</h3>
						<button onClick={toggleSidebar} className="text-gray-500 hover:text-gray-900 p-2 rounded-full">
							<svg
								xmlns="http://www.w3.org/2000/svg"
								fill="none"
								viewBox="0 0 24 24"
								stroke="currentColor"
								className="w-5 h-5"
							>
								<path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" />
							</svg>
						</button>
					</div>

					{/* Parent Intent */}
					<div className="mb-4">
						<label className="block text-sm text-gray-700">Parent Intent</label>
						<select
							value={selParentIntent}
							onChange={(e) => setSelParentIntent(e.target.value)}
							className="block w-full p-2 mt-1 text-sm border border-gray-300 rounded-md"
						>
							<option value="">All</option>
							{parentIntents.map((intent) => (
								<option key={intent} value={intent}>
									{intent}
								</option>
							))}
						</select>
					</div>

					{/* Child Intent */}
					<div className="mb-4">
						<label className="block text-sm text-gray-700">Child Intent</label>
						<select
							value={selChildIntent}
							onChange={(e) => setSelChildIntent(e.target.value)}
							className="block w-full p-2 mt-1 text-sm border border-gray-300 rounded-md"
						>
							<option value="">All</option>
							{childIntents.map((intent) => (
								<option key={intent} value={intent}>
									{intent}
								</option>
							))}
						</select>
					</div>

					{/* Date Range with Time */}
					<div className="mb-4">
						<label className="block text-sm text-gray-700">Assigned Date</label>
						<div className="flex space-x-2">
							<input
								type="date"
								value={startDate}
								onChange={(e) => setStartDate(e.target.value)}
								className="block w-full p-2 text-sm border border-gray-300 rounded-md"
							/>
							<input
								type="time"
								value={startTime}
								onChange={(e) => setStartTime(e.target.value)}
								className="block w-full p-2 text-sm border border-gray-300 rounded-md"
							/>
						</div>
					</div>
					<div className="mb-4">
						<label className="block text-sm text-gray-700">Due Date</label>
						<div className="flex space-x-2">
							<input
								type="date"
								value={endDate}
								onChange={(e) => setEndDate(e.target.value)}
								className="block w-full p-2 text-sm border border-gray-300 rounded-md"
							/>
							<input
								type="time"
								value={endTime}
								onChange={(e) => setEndTime(e.target.value)}
								className="block w-full p-2 text-sm border border-gray-300 rounded-md"
							/>
						</div>
					</div>
				</div>

				{/* Apply and Reset Buttons */}
				<div className="flex justify-end space-x-4">
					<button
						onClick={() => {
							setStartDate('');
							setEndDate('');
							setStartTime('');
							setEndTime('');
							setSelParentIntent('');
							setSelChildIntent('');
						}}
						className="text-sm text-gray-600 hover:text-gray-900"
					>
						Reset
					</button>
					<button onClick={handleApplyFilters} className="px-4 py-2 text-sm bg-blue-600 text-white rounded-md">
						Apply
					</button>
				</div>
			</div>
		</div>
	);
};

export default FilterSidebar;
